
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPrintScreenProposal as ObiPrintScreenProposalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-print-screen-proposal.js';
 
 
 

 
 export const ObiPrintScreenProposal = createComponent({
   react: React,
   tagName: 'obi-print-screen-proposal',
   elementClass: ObiPrintScreenProposalElement,
   events: {
     
   }
  });
 
 